import { api } from '@marketplace-web/core-api/core-api-client-data'

import { GetFeedbackSummaryResp } from '../types/feedback-summary'

export const getFeedbackSummary = (userId: number) =>
  api.get<GetFeedbackSummaryResp>(`/user_feedbacks/summary?user_id=${userId}`)
